export function decodeGoogleJwt(token) {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
    return JSON.parse(jsonPayload);
  } catch (e) {
    return null;
  }
}

export function validateGoogleIdToken(rawCredential, { expectedAud }) {
  const errors = [];
  if(!rawCredential) {
    errors.push('missing credential');
    return { valid: false, errors, payload: null };
  }
  const payload = decodeGoogleJwt(rawCredential);
  if(!payload) {
    errors.push('decode failed');
    return { valid: false, errors, payload: null };
  }
  const now = Math.floor(Date.now()/1000);
  if(!['https://accounts.google.com','accounts.google.com'].includes(payload.iss)) {
    errors.push('invalid iss');
  }
  if(payload.aud !== expectedAud) {
    errors.push('aud mismatch');
  }
  if(typeof payload.exp !== 'number' || payload.exp <= now) {
    errors.push('token expired');
  }
  if(!payload.sub) {
    errors.push('missing sub');
  }
  if(payload.email && payload.email_verified === false) {
    errors.push('email not verified');
  }
  return { valid: errors.length === 0, errors, payload };
}
